import React from 'react'
import RegisterForm from '../Components/Authentication/RegisterForm'

const SignupPage = () => {
  return (
    <main className='container d-flex align-items-center justify-content-center vh-100'>
      <RegisterForm></RegisterForm>
    </main>
  )
}

export default SignupPage